import { create } from 'zustand';
import { apiFetch } from '../lib/api';

interface SafeUser {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
}

interface AuthState {
  token: string | null;
  user: SafeUser | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  googleLogin: (idToken: string) => Promise<void>;
  logout: () => void;
  checkAuth: () => Promise<void>;
  skipAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem('token'),
  user: null,
  loading: true,

  login: async (email, password) => {
    const data = await apiFetch<{ token: string; user: SafeUser }>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    localStorage.setItem('token', data.token);
    set({ token: data.token, user: data.user });
  },

  googleLogin: async (idToken: string) => {
    const data = await apiFetch<{ token: string; user: SafeUser }>('/api/auth/google', {
      method: 'POST',
      body: JSON.stringify({ id_token: idToken }),
    });
    localStorage.setItem('token', data.token);
    set({ token: data.token, user: data.user });
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ token: null, user: null });
  },

  checkAuth: async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      set({ loading: false });
      return;
    }
    try {
      const data = await apiFetch<{ user: SafeUser }>('/api/auth/me');
      set({ user: data.user, token, loading: false });
    } catch {
      localStorage.removeItem('token');
      set({ token: null, user: null, loading: false });
    }
  },

  skipAuth: () => set({ loading: false }),
}));
